import { ICountryAsset, ICountryAssetLite } from "models/Assets/ICountryAsset";
import {
  ICategoryAsset,
  ICategoryLiteAsset, ICustomCategoryAsset,
} from "models/Assets/ICategoryAsset";
import { Localization } from "../classes/Localization.class";
import { ICityAsset } from "models/Assets/ICityAsset";
import {INeighborhoodAsset, INeighborhoodLiteAsset} from "models/Assets/INeighborhoodAsset";
import EssentialData from "../../../private/classes/EssentialData.class";
import { labelHelper, urlHelper } from "helpers/themeHelpers";
import { ICpOption } from "models/Assets/IDynamicAttributes";
import { ICoreModels, ISeoCache, ITypeBreadcrumb } from "../types/types";
import {TypeAllowedCustomLandingBaseNames} from "componentScreens/LandingPages";
import {isCategoryVipMobileNumbers} from "helpers/osHelpers";
import { EnumScreenNames } from "../../../enums/EnumScreenNames";

export enum EnumSeoItemType {
  TYPE_COUNTRY = 0,
  TYPE_CITY = 1,
  TYPE_CATEGORY = 2,
  TYPE_PARAM = 3,
  TYPE_NEIGHBORHOOD = 4,
  TYPE_SHORT_CATEGORY = 5,
  TYPE_STATIC_CATEGORY_TERM = 6,
  TYPE_SHOPS_CATEGORIES = 7,
  TYPE_SHOPS_PROFILE = 8,
  TYPE_SHOPS_MAIN_PAGE = 9,
  TYPE_CAR_FAX = 10,
  TYPE_REAL_ESTATE_PRICES = 11,
  TYPE_DEFAULT_CP = 100,
}

enum EnumSeoItemStatus {
  ACTIVE_STATUS = 1,
  INACTIVE_STATUS = 0,
}

export enum EnumSeoItemLevel {
  LEVEL_COUNTRY = 0,
  LEVEL_CITY = 1,
  LEVEL_CATEGORY = 2,
  LEVEL_SUBCATEGORY = 3,
  LEVEL_PARAM1 = 4,
  LEVEL_PARAM2 = 5,
  LEVEL_PARAM3 = 6,
  LEVEL_PARAM4 = 7,
  LEVEL_REAL_ESTATE_PRICES_LANDING = 11,
  LEVEL_REAL_ESTATE_PRICES_OTHER = 12,
}

export default class SeoItemModel  {
  declare id: number;
  declare name: string;
  declare label_ar: string;
  declare label_en: string;
  declare model_type: number;
  declare level: number;
  declare page_title_ar: string;
  declare page_title_en: string;
  declare page_description_ar: string;
  declare page_description_en: string;
  declare breadcrumbs_ar: string;
  declare breadcrumbs_en: string;
  declare page_og_title_ar: string;
  declare page_og_title_en: string;
  declare page_h1_title_ar: string;
  declare page_h1_title_en: string;
  declare page_meta_description_ar: string;
  declare page_meta_description_en: string;
  declare page_meta_og_description_ar: string;
  declare page_meta_og_description_en: string;
}


export const getItemShop = (
    seoCache: ISeoCache,
    country: ICountryAssetLite
): SeoItemModel => {
    return seoCache.getSeoItemShopRecord(
        country.id,
    );
  }

export const findItemCountry = (
  seoCache: ISeoCache,
  country: ICountryAssetLite,
  city: ICityAsset
): SeoItemModel => {
  if (city) {
    return seoCache.getSeoItemRecord(
      country.id,
      EnumSeoItemType.TYPE_CITY,
      city.id,
      EnumSeoItemLevel.LEVEL_CITY,
      country.id
    );
  } else {
    return seoCache.getSeoItemRecord(
      country.id,
      EnumSeoItemType.TYPE_COUNTRY,
      country.id,
      EnumSeoItemLevel.LEVEL_COUNTRY
    );
  }
};

export const findShopCateogry = (
  seoCache: ISeoCache,
  country: ICountryAssetLite,
  category: ICategoryAsset
): SeoItemModel => {
  return findSeoItem(
    seoCache,
    country,
    EnumSeoItemType.TYPE_SHOPS_CATEGORIES,
    Number(category.id),
    EnumSeoItemLevel.LEVEL_CATEGORY,
    country.id
  );
};

export const factoryNeighbourhoodSeoItem = (
  neighborhood: INeighborhoodAsset,
): SeoItemModel => {
  const $model = new SeoItemModel();
  $model.page_description_ar = "";
  $model.page_description_en = "";

  $model.page_title_ar = $model.page_og_title_ar =
      'اعلانات السوق المفتوح في __market_name__ __neighborhood__ : سيارات ومركبات : عقارات للبيع وللايجار : أسعار تنافسية : __market_name__ __neighborhood__';
  $model.page_title_en = $model.page_og_title_en =
      'For Sale & For Rent in __market_name__ __neighborhood__ : Best Prices : Real Estate : Cars and Bikes';
  $model.page_meta_description_ar = $model.page_meta_og_description_ar =
      'اعلانات السوق المفتوح للبيع وللايجار في __market_name__ __neighborhood__، سيارات وعقارات والكترونيات، افضل الاسعار، ادخل الان وتصفح الاعلانات!';
  $model.page_meta_description_en = $model.page_meta_og_description_en =
      'Check OpenSooq Listings for sale and for rent in __market_name__ __neighborhood__. All what you need in the best prices with the best deals.';
  $model.page_h1_title_ar = 'اعلانات للبيع وللايجار في __market_name__ __neighborhood__';

  $model.page_h1_title_en = 'For Sale & For Rent in __market_name__ __neighborhood__';
  return $model;

};

export const factoryDefaultCpsSeoItem = (): SeoItemModel => {
  const $model = new SeoItemModel();
  $model.page_description_ar = "";
  $model.page_description_en = "";

  $model.page_title_ar = $model.page_og_title_ar =
      '__param1__ للبيع في __market_name__ : افضل الاسعار';
  $model.page_title_en = $model.page_og_title_en =
      '__param1__ for sale in __market_name__';
  $model.page_meta_description_ar = $model.page_meta_og_description_ar =
      '__param1__ للبيع في __market_name__ بافضل الاسعار، تصفح الموقع الان لمشاهدة جميع الاعلانات وسهولة التواصل مع البائع';
  $model.page_meta_description_en = $model.page_meta_og_description_en =
      '__param1__ for Sale in __market_name__ with best prices, check the website now to see all listings and contact easily with the seller';
  $model.page_h1_title_ar = '__param1__ للبيع في __market_name__';

  $model.page_h1_title_en = '__param1__ For Sale in __market_name__';
  return $model;

};

export const factoryCustomLandingSeoItem = (
  category: ICustomCategoryAsset,
): SeoItemModel => {
  const baseName = category.reporting_name as TypeAllowedCustomLandingBaseNames;

  const $model = new SeoItemModel();
  $model.page_description_ar = "";
  $model.page_description_en = "";

  switch (baseName) {
    case "RealEstate":
      $model.page_h1_title_ar = 'عقارات في __market_name__ __neighborhood__';
      $model.page_meta_description_ar = 'عقارات في __market_name__ __neighborhood__، شقق وفلل ومخازن، افضل الاسعار من المالك او من مكاتب عقارية موثوقة، ادخل الان وتصفح جميع الاعلانات';
      $model.page_title_ar = 'عقارات في __market_name__ __neighborhood__ : شقق : فلل : محلات تجارية ومشاريع : افضل الاسعار';
      $model.page_h1_title_en = 'Real Estate in __market_name__ __neighborhood__';
      $model.page_meta_description_en = 'Real Estate in Jordan, apartments, villas, lands. Find what you’re looking for Today! Perfect location, Best Deals. Browse the website now to see all listings';
      $model.page_title_en = 'Real Estate in __market_name__ __neighborhood__ : Apartments : Villa : Shops and Projects : Best Prices';
      break
    case "Fashion":
      $model.page_h1_title_ar = 'أزياء في __market_name__ __neighborhood__';
      $model.page_meta_description_ar = 'ازياء للبيع بافضل وارخص الاسعار في __market_name__ __neighborhood__، تصفح الموقع الان لمشاهدة جميع الاعلانات عن الموضة الرجالية، النساية، وملابس الاطفال';
      $model.page_title_ar = 'أزياء للبيع : أزياء رجالية ونسائية : ملابس اطفال : ارخص الاسعار في __market_name__ __neighborhood__';
      $model.page_h1_title_en = 'Fashion in __market_name__ __neighborhood__';
      $model.page_meta_description_en = 'Fashion for sale with best prices in __market_name__ __neighborhood__, check the website now to see all listings for women, men, and kids clothes and fashion';
      $model.page_title_en = 'Fashion for Sale in __market_name__ __neighborhood__ : Mens Fashion : Women : Kids Clothes : Best Prices';
      break
    case "Electronics":
      $model.page_h1_title_ar = 'الكترونيات للبيع';
      $model.page_meta_description_ar = 'تصفح مختلف انواع الاكترونيات للبيع في __market_name__ __neighborhood__ خلال السوق المفتوح. موبايلات، تابلت، العاب فيديو والعديد من الالكترونيات';
      $model.page_title_ar = 'الكترونيات للبيع : موبايل وتابلت : العاب فيديو : أجهزة : في __market_name__ __neighborhood__';
      $model.page_h1_title_en = 'Electronics for Sale';
      $model.page_meta_description_en = 'Check a variety of electronics for sale in __market_name__ __neighborhood__ through OpenSooq. Mobiles, tablets, video games and all kinds of electronics.';
      $model.page_title_en = 'Electronics for Sale : Mobile&Tablet : Consoles : Video Games: in __market_name__ __neighborhood__';
      break
  }

  return $model;

};
export const findSeoItem = (
  seoCache: ISeoCache,
  country: ICountryAssetLite,
  model_type: EnumSeoItemType,
  model_id: number,
  level: EnumSeoItemLevel,
  parent_model_id?: number
): SeoItemModel => {
  return seoCache.getSeoItemRecord(
    country.id,
    model_type,
    model_id,
    level,
    parent_model_id
  ) || null;
};

export const generateBreadcrumbs = (
  country: ICountryAssetLite,
  category: ICategoryAsset,
  subCategory: ICategoryAsset,
  cpOptions: ICpOption[],
  city: ICityAsset,
  neighbourhood: INeighborhoodLiteAsset,
  localization: Localization,
  firstCrumb: ITypeBreadcrumb = null
): ITypeBreadcrumb[] => {
  const breadcrumbs: ITypeBreadcrumb[] = [];

  firstCrumb = firstCrumb ?? {
    label: labelHelper(country, localization.lang),
    url: `/${localization.lang}`,
    url2: `/${localization.lang2}`,
  };

  breadcrumbs.push(firstCrumb);

  if (city) {
    breadcrumbs.push({
      label: labelHelper(city, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(city, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(city, localization.lang2),
    });
  }
  if (neighbourhood) {
    breadcrumbs.push({
      label: labelHelper(neighbourhood, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(neighbourhood, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(neighbourhood, localization.lang2),
    });
  }

  if (category) {
    breadcrumbs.push({
      label: labelHelper(category, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(category, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(category, localization.lang2),
    });
  }
  if (subCategory) {
    breadcrumbs.push({
      label: labelHelper(subCategory, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(subCategory, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(subCategory, localization.lang2),
    });
  }
  (cpOptions ?? []).forEach((cpOption) => {
    breadcrumbs.push({
      label: labelHelper(cpOption, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(cpOption, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(cpOption, localization.lang2),
    });
  });

  return breadcrumbs;
};

export const schemaOrg = (
  country: ICountryAssetLite,
  category: ICategoryLiteAsset,
  subCategory: ICategoryLiteAsset,
  cpOptions: ICpOption[],
  city: ICityAsset,
  neighbourhood: INeighborhoodLiteAsset,
  localization: Localization
) => {
  let generatedBreadcrumbs = generateBreadcrumbs(
    country,
    category,
    subCategory,
    cpOptions,
    city,
    neighbourhood,
    localization
  );
  let schema: any[] = [];

  generatedBreadcrumbs?.forEach(function (breadcrumbs) {
    schema.push({
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs,
    });
  });
  return schema;
};

function getHrefLangsShobiddak(  essentialData: EssentialData,
                                 localization: Localization,
                                 country: ICountryAsset,
                                 city?: ICityAsset,
                                 neighborhood?: INeighborhoodLiteAsset,
                                 category?: ICategoryAsset,
                                 subCategory?: ICategoryAsset,
                                 cpOptions?: ICpOption[],
                                 specialPhoneNumber?: []
) {
  let hrefLangs: { href: string; hreflang: string }[] = [];
const abbr = "ps";
  ["en", "ar"].forEach((lang) => {
    const link = [
      urlHelper(city, lang),
      urlHelper(neighborhood, lang),
      urlHelper(category?.aliasesInOtherCountries?.[abbr], lang),
      urlHelper(subCategory?.aliasesInOtherCountries?.[abbr], lang),
      ...(cpOptions || []).map((option) => urlHelper(option, lang)),
    ]
        .filter(Boolean)
        .join("/");

    hrefLangs.push({
      href: `https://__host_name__/${lang}/${link}`,
      hreflang: `${lang}`,
    });

  });

  return hrefLangs;

}

export const getHrefLangs = (
  essentialData: EssentialData,
  localization: Localization,
  country: ICountryAsset,
  city?: ICityAsset,
  neighborhood?: INeighborhoodLiteAsset,
  category?: ICategoryAsset,
  subCategory?: ICategoryAsset,
  cpOptions?: ICpOption[]
) => {


  if (process.env.NEXT_PUBLIC_CUSTOM_THEME == "shobiddak") {
    return getHrefLangsShobiddak(essentialData,
        localization,
        country,
        city,
        neighborhood,
        category,
        subCategory,
        cpOptions
    );
  }


  let countries: ICountryAsset[];
  const currentCountry = country.abbreviation;
  let currentAbbr;
  if (city || neighborhood) {
    countries = [country];
  } else {
    countries = essentialData?.getCountries_ServerOnly();
  }
  let hrefLangs: { href: string; hreflang: string }[] = [];
  let specialPhoneNumber: { href: string; hreflang: string }[] = [];
  countries.forEach((country) => {
    const abbr = country.abbreviation;
    currentAbbr = currentCountry === abbr ? currentCountry : null;
    ["en", "ar"].forEach((lang) => {
      const link = [
        urlHelper(city, lang),
        urlHelper(neighborhood, lang),
        urlHelper(category?.aliasesInOtherCountries?.[abbr], lang),
        urlHelper(subCategory?.aliasesInOtherCountries?.[abbr], lang),
        ...(cpOptions || []).map((option) => urlHelper(option, lang)),
      ]
        .filter(Boolean)
        .join("/");
      if (
        isCategoryVipMobileNumbers(subCategory) &&
        cpOptions &&
        currentCountry === currentAbbr
      ) {
        specialPhoneNumber.push({
          href: `https://${currentCountry}.__host_name__/${lang}/${link}`,
          hreflang: `${lang}-${currentCountry}`,
        });
      } else {
        hrefLangs.push({
          href: `https://${abbr}.__host_name__/${lang}/${link}`,
          hreflang: `${lang}-${abbr}`,
        });
      }
    });
  });
  return specialPhoneNumber.length > 0 ? specialPhoneNumber : hrefLangs;
};

export const getParsedRequestData = (
  seoCache: ISeoCache,
  country: ICountryAsset,
  city: ICityAsset,
  neighborhood: INeighborhoodLiteAsset,
  category: ICategoryAsset,
  subCategory: ICategoryAsset,
  cpOptions: ICpOption[] = []
): {
  type: EnumSeoItemType;
  level: EnumSeoItemLevel;
  model_id: number;
  parent_model_id: number;
} => {
  if (subCategory) {
    if ((cpOptions ?? []).length != 0) {
      const dynamicAttributeId = Number(cpOptions[cpOptions.length - 1].id);
      const guessedDynamicOption = {
        type: EnumSeoItemType.TYPE_PARAM,
        level: EnumSeoItemLevel.LEVEL_PARAM1 + cpOptions.length - 1,
        model_id: dynamicAttributeId,
        parent_model_id: Number(subCategory.id),
      };
      if (
        findSeoItem(
          seoCache,
          country,
          guessedDynamicOption.type,
          dynamicAttributeId,
          guessedDynamicOption.level,
          guessedDynamicOption.parent_model_id
        ) != null
      ) {
        return guessedDynamicOption;
      } else if (
        findSeoItem(
          seoCache,
          country,
          EnumSeoItemType.TYPE_SHORT_CATEGORY,
          Number(subCategory.id),
          EnumSeoItemLevel.LEVEL_PARAM1,
          Number(subCategory.parent_id)
        ) != null
      ) {
        return {
          type: EnumSeoItemType.TYPE_SHORT_CATEGORY,
          level: EnumSeoItemLevel.LEVEL_PARAM1,
          model_id: Number(subCategory.id),
          parent_model_id: Number(subCategory.parent_id),
        };
      } else {
        return {
          type: EnumSeoItemType.TYPE_DEFAULT_CP,
          level: null,
          model_id: null,
          parent_model_id: null,
        };
      }
    }
    return {
      type: EnumSeoItemType.TYPE_CATEGORY,
      level: EnumSeoItemLevel.LEVEL_SUBCATEGORY,
      model_id: Number(subCategory.id),
      parent_model_id: Number(subCategory.parent_id),
    };
  } else if (category) {
    return {
      type: EnumSeoItemType.TYPE_CATEGORY,
      level: EnumSeoItemLevel.LEVEL_CATEGORY,
      model_id: Number(category.id),
      parent_model_id: country.id,
    };
  } else if (city?.id) {
    if(neighborhood?.id){
      return {
        type: EnumSeoItemType.TYPE_NEIGHBORHOOD,
        level: null,
        model_id: null,
        parent_model_id: null,
      };
    }
    return {
      type: EnumSeoItemType.TYPE_CITY,
      level: EnumSeoItemLevel.LEVEL_CITY,
      model_id: city.id,
      parent_model_id: country?.id,
    };
  }
  return {
    type: EnumSeoItemType.TYPE_COUNTRY,
    level: EnumSeoItemLevel.LEVEL_COUNTRY,
    model_id: country.id ?? 0,
    parent_model_id: null,
  };
};

export function getPlaceholders(
  seoItemModel: SeoItemModel,
  country: ICountryAsset,
  localization: Localization,
  coreModels: ICoreModels,
  pageNumber: Number = null
): any {
  const { city, neighborhood, category, subCategory, cpOptions } = coreModels;
  let $ret = {};
  const $defaults = {
    __website__: "",
    __main_category__: "",
    __city__: "",
    __country__: "",
    __sub_category__: "",
    __neighborhood__: "",
    __current__: "",
    __parent__: "",
    __title__: "",
    __tag__: "",
    __subtag__: "",
    __param1__: "",
    __param2__: "",
    __param3__: "",
    __param4__: "",
    __page_num__: "",
  };

  if (process.env.NEXT_PUBLIC_CUSTOM_THEME=="shobiddak") {
    $ret["__website__"] = localization.lang=="en"? "ShoBiddak" : "شو بدك";
  } else {
    $ret["__website__"] = localization.lang=="en"? "OpenSooq" : "السوق المفتوح";
  }

  if (pageNumber){
    $ret["__page_num__"] = pageNumber;
  }

  if (city) {
    $ret["__market_name__"] = labelHelper(city, localization.lang);
    $ret["__city__"] = labelHelper(city, localization.lang);
  } else {
    $ret["__market_name__"] = labelHelper(country, localization.lang);
  }
  const nHoodPrefix =
    country.abbreviation === "sa" && localization.lang === "ar" ? "حي " : "";
  $ret["__country__"] = labelHelper(country, localization.lang);
  if (category)
    $ret["__main_category__"] = labelHelper(category, localization.lang);
  if (subCategory)
    $ret["__sub_category__"] = labelHelper(subCategory, localization.lang);
  if (neighborhood)
    $ret["__neighborhood__"] =
      nHoodPrefix + labelHelper(neighborhood, localization.lang);
  const $l = (cpOptions || [])?.length;
  const langsuffix = localization.lang == "ar" ? "" : "_en";
  for (let i = 1; i <= $l; ++i) {
    $ret[`__param${i}__`] = cpOptions[i - 1][`label${langsuffix}`];
  }
  if (seoItemModel?.model_type == EnumSeoItemType.TYPE_PARAM) {
    $ret["__current__"] = cpOptions[$l - 1][`label${langsuffix}`];
    if (cpOptions?.[$l - 2]?.[`label${langsuffix}`])
      $ret["__parent__"] = cpOptions[$l - 2][`label${langsuffix}`];
  } else if (
    seoItemModel?.model_type == EnumSeoItemType.TYPE_CATEGORY ||
    seoItemModel?.model_type == EnumSeoItemType.TYPE_SHOPS_CATEGORIES
  ) {
    if (seoItemModel?.level == EnumSeoItemLevel.LEVEL_SUBCATEGORY) {
      $ret["__current__"] = labelHelper(subCategory, localization.lang);
      $ret["__parent__"] = labelHelper(category, localization.lang);
    } else {
      $ret["__current__"] = labelHelper(category, localization.lang);
    }
  } else if (seoItemModel?.model_type == EnumSeoItemType.TYPE_SHORT_CATEGORY) {
    const $values = cpOptions.map((cpOption) => {
      if (cpOption.fieldName === "Rooms") {
        const url = "url_name_" + localization.lang;
        return cpOption[url].replaceAll("-", " ").replaceAll(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      }
      const $field = "seo_value_" + localization.lang;
      const $label = localization.lang == "ar" ? "label" : "label_en";
      return cpOption[$field]
        ? cpOption[$field].replaceAll("__VALUE__", cpOption[$label])
        : cpOption[$label];
    });
    $ret["__title__"] = $values.join(" ");
  }
  return { ...$defaults, ...$ret };
}

export const generateShopsBreadcrumbs = (
  country: ICountryAssetLite,
  category: ICategoryAsset,
  localization: Localization,
): ITypeBreadcrumb[] => {
  const breadcrumbs: ITypeBreadcrumb[] = [];

  breadcrumbs.push({
    label: labelHelper(country, localization.lang),
    url: `/${localization.lang}`,
    url2: `/${localization.lang2}`,
  });

  const linkAr = `/ar/متاجر`;
  const linkEn = `/en/shops`;
  breadcrumbs.push({
    label: localization.trPlaceholder(
      EnumScreenNames.SHOPS_LIST_SCREEN,
      "shops"
    ),
    url: localization.lang == "ar" ? linkAr : linkEn,
    url2: localization.lang != "ar" ? linkAr : linkEn,
  });
  if (category) {
    breadcrumbs.push({
      label: labelHelper(category, localization.lang),
      url:
        breadcrumbs[breadcrumbs.length - 1].url +
        "/" +
        urlHelper(category, localization.lang),
      url2:
        breadcrumbs[breadcrumbs.length - 1].url2 +
        "/" +
        urlHelper(category, localization.lang2),
    });
  }
  return breadcrumbs;
};

export const getAutosLandingPageFAQ = (
    localization: Localization
): any[] => {
  return localization.lang == "en" ? [
    {
      "question": "Can I find both new and used cars on OpenSooq?",
      "answer": "Absolutely! OpenSooq features a vast selection of both new and used cars. You can easily filter your search based on your preference."
    },
    {
      "question": "How can I be assured of the quality of used cars listed on the platform?",
      "answer": "While OpenSooq hosts the platform, the condition and quality of used cars depend on the individual sellers. We recommend buyers communicate directly with sellers, ask detailed questions about the vehicle, and, where possible, arrange a physical inspection or test drive to ensure satisfaction before purchase."
    },
    {
      "question": "Are there options for renting cars on OpenSooq?",
      "answer": "Yes, OpenSooq offers a 'Cars for Rent' category, featuring numerous car rental options to suit your temporary mobility needs."
    },
    {
      "question": "I'm interested in selling my car. How do I list it on OpenSooq?",
      "answer": "You can easily list your car for sale on OpenSooq. Simply create an account, click on 'Post an Ad,' fill out the required details about your vehicle, upload clear pictures, and submit."
    },
    {
      "question": "Do you offer other automotive-related items other than cars?",
      "answer": "Yes, OpenSooq offers a variety of automotive-related items such as VIP car plates, car spare parts, wheels and rims, and car accessories to enhance your vehicle's identity and performance."
    }
  ] : [
    {
      "question": "هل يمكنني أن أجد سيارة على موقع السوق المفتوح؛ سواء جديدة أو مُستعملة؟",
      "answer": "بالتأكيد، يتميز السوق المفتوح بتوفير مجموعة كبيرة ومُتنوعة من السيارات الجديدة والمُستعملة، بحيث يُمكنك تصفية نتائج البحث حسب تفضيلاتك بكل بسهولة."
    },
    {
      "question": "كيف يُمكنني أن أتأكد من كفاءة السيارات المُستعملة المُعلن عنها على السوق المفتوح؟",
      "answer": "السوق المفتوح هو منصة إعلانات مبوبة، بحيث تعتمد حالة السيارات المُستعملة به على البائعين المُعلنين، لذا نوصي المُشترين بالتواصل مباشرةً مع البائعين وطرح أسئلة مُفصلة حول السيارة، وإن أمكن، ننصح بترتيب موعد فحص للسيارة على أرض الواقع أو إجراء اختبار قيادة لضمان تلبيتها لطلبهم."
    },
    {
      "question": "هل يوجد تنوع في السيارات المعروضة للإيجار على السوق المفتوح؟",
      "answer": "نعم، بحيث يضم قسم سيارات للإيجار على موقع السوق المفتوح مجموعة واسعة ومتنوعة من خيارات السيارات المعروضة للإيجار، لتناسب احتياجات التنقل المؤقتة لديك."
    },
    {
      "question": "أنا مُهتم ببيع سيارتي، كيف يُمكنني نشر إعلان على موقع السوق المفتوح؟",
      "answer": "بإمكانك نشر إعلان سيارة للبيع بكل سهولة على موقع السوق المفتوح، فما عليك سوى إنشاء حساب، ثم النقر على خيار 'أضف إعلان'، ثم تعبئة المعلومات المطلوبة حول سيارتك، وإرفاق بعض الصور لها، وأخيراً تأكيد إعلانك."
    },
    {
      "question": "هل يوجد على السوق المفتوح أقسام أخرى تتعلق بالمركبات بخلاف سيارات للبيع؟",
      "answer": "نعم، يوجد على السوق المفتوح الكثير من العناصر الاخرى ذات الصلة بعالم المركبات، مثل: لوحات السيارات المُميزة، وقطع غيار السيارات، والعجلات والجنوط، وإكسسوارات السيارات الرائعة لتمييز سيارتك والتحسين من أدائها."
    }
  ]
}